import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 0.6; transform: scale(0.98); }
  50% { opacity: 1; transform: scale(1.02); }
`;

const SpinnerOverlay = styled.div`
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  padding: 2rem;
`;

const RingContainer = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OuterRing = styled.div`
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid rgba(30, 58, 138, 0.15);
  border-top-color: var(--primary-blue, #1e3a8a);
  border-right-color: var(--accent-gold, #fbbf24);
  border-radius: 50%;
  animation: ${spin} 0.9s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;
`;

const InnerDot = styled.div`
  width: 14px;
  height: 14px;
  background: var(--primary-blue, #1e3a8a);
  border-radius: 50%;
  animation: ${pulse} 1.4s ease-in-out infinite;
`;

const LoadingText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-secondary, #64748b);
  letter-spacing: 0.5px;
  margin: 0;
`;

const LoadingSpinner = () => {
  return (
    <SpinnerOverlay>
      <RingContainer>
        <OuterRing />
        <InnerDot />
      </RingContainer>
      <LoadingText>Loading...</LoadingText>
    </SpinnerOverlay>
  );
};

export default LoadingSpinner;
